import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledRoot = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.25, 1.5),
    borderRadius: '20px',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    height: '28px',
    whiteSpace: 'nowrap',
    transition: theme.transitions.create('all', {
        duration: theme.transitions.duration.shorter,
    }),
}));

export const StyledDot = styled(Box)(({ theme }) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
}));
